import dayjs from 'dayjs';
import _ from 'lodash';
import { analyzeOrder } from './index';

export class Parser {
    constructor () {
        this.data = [];

        this.riskAnalysis = {};
        this.timeSpanLength = 0;
        this.timeSpanStart = '2999-01-01';
        this.timeSpanEnd = '2000-01-01';
        this.totalIncome = 0;
        this.totalExpense = 0;
        this.avgMonthIncome = 0;
        this.avgMonthExpense = 0;
        this.incomeMonthly = {};
        this.expenseMonthly = {};
        this.commonTradings = {};   //记录常用支付方式
        this.categoryMonthly = {};
        this.partyTrading = {}; //记录与人的交易流水
        this.usuryPlatform = new Map(); //高息借贷场景
        this.leasePlatform = new Map(); //租赁场景平台
        this.financialPlatform = new Map(); //金融场景平台
        this.largeAmountOrdersCount = { //大额交易订单数量
            count: 0,
            orders: []
        }; 
        this.lastMonthRepayment = {
            count: 0,
            amount: 0,
            orders: []
        }
        this.familyConsumption = {
            count: 0,
            amount: 0,
            orders: []
        };
        this.vehicleConsumption = {
            count: 0,
            amount: 0,
            orders: []
        }
    }

    load ( data ){
        this.data = data;
        this.data.forEach( item => {
            //判断最早时间
            if( dayjs(item.TIME_YMD).isBefore(this.timeSpanStart) ) {
                this.timeSpanStart = item.TIME_YMD;
            }
            //判断最晚时间
            if( dayjs(item.TIME_YMD).isAfter(this.timeSpanEnd) ) {
                this.timeSpanEnd = item.TIME_YMD;
            }

            //判断订单场景
            item.SCENE = analyzeOrder(item);

            //计算总收入和总支出
            if( item._IE === 0 ) {
                this.totalIncome += item.AMOUNT;
            }
            else if( item._IE === 1 ) {
                this.totalExpense += item.AMOUNT;
            }
            //计算每月收入和支出
            const monthKey = item.TIME_YM;
            if( item._IE === 0 ) {
                this.incomeMonthly[monthKey] = _.round((this.incomeMonthly[monthKey] || 0) + item.AMOUNT);
            }
            else if( item._IE === 1 ) {
                this.expenseMonthly[monthKey] = _.round((this.expenseMonthly[monthKey] || 0) + item.AMOUNT);
            }
            //统计常用卡
            this._commonCardAnalysis( item );
            //统计消费类型
            this._categoryAnalysis( item );
            //统计与人的交易流水
            this._traderAnalysis( item );
            this._riskAnalysis( item );
        });
        //计算时间跨度
        this.timeSpanLength = dayjs(this.timeSpanEnd).diff(dayjs(this.timeSpanStart), 'month') + 1;
        //计算平均收入和支出
        if( this.timeSpanLength === 0 ) {
            this.timeSpanLength = 1; //避免除以0
        }
        //四舍五入
        this.totalIncome = _.round(this.totalIncome);
        this.totalExpense = _.round(this.totalExpense);
        this.avgMonthIncome = _.round(this.totalIncome / this.timeSpanLength);
        this.avgMonthExpense = _.round(this.totalExpense / this.timeSpanLength);
    }

    // 分析常用卡
    _commonCardAnalysis ( item ) {

        let trading = item.TRADING;

        let baseOptions = {
            count: 0, 
            withdrawal: 0, 
            expenditure: 0, 
            other: 0
        }

        if( /储蓄卡|信用卡/i.test(trading) ) {
            let cardNo = item.TRADING.slice( 0, item.TRADING.indexOf('&') !== -1 ? item.TRADING.indexOf('&') : item.TRADING.length );
            trading = cardNo;
            let cardType = trading.indexOf('信用卡') > -1 ? 'credit' : 'debit';
            Object.assign(baseOptions, {
                cardNo,
                cardType
            });
        }
        else {
            //删除空格和&符号后的内容
            trading = trading.replace(/&.+/g, '').replace(/\(.+\)/g, '');
        }

        var entity = _.get( this.commonTradings, [ trading ], baseOptions);

        if( item._IE === 0 ) {
            entity.count += 1;
            entity.withdrawal = _.round( entity.withdrawal + (item.AMOUNT || 0));
            _.set( this.commonTradings, [ trading ], entity );
        }
        else if( item._IE === 1 ) {
            entity.count += 1;
            entity.expenditure = _.round( entity.expenditure + (item.AMOUNT || 0));
            _.set( this.commonTradings, [ trading ], entity );
        }
        else {
            entity.count += 1;
            entity.other = _.round( entity.other + (item.AMOUNT || 0));
            _.set( this.commonTradings, [ trading ], entity );
        }
    }

    _categoryAnalysis ( item ) {
        let $key = item.TIME_YM;
        let entity = _.get( this.categoryMonthly, $key, {});

        let partyEntity = _.get( entity, [ item.PARTY ], { 
            party: item.PARTY,
            industry: item.SCENE,
            count: 0, 
            income: 0, 
            incomeOrders: [],
            expense: 0, 
            expenseOrders: [],
            other: 0,
            otherOrders: []
        });

        partyEntity.count += 1;

        if( item._IE === 0 ) {
            partyEntity.income += (item.AMOUNT || 0);
            partyEntity.incomeOrders.push(item.ID);
        }
        else if( item._IE === 1 ) {
            partyEntity.expense += (item.AMOUNT || 0);
            partyEntity.expenseOrders.push(item.ID);
        }
        else {
            partyEntity.other += (item.AMOUNT || 0);
            partyEntity.otherOrders.push(item.ID);
        }

        _.set( entity, [ item.PARTY ], partyEntity );
        _.set( this.categoryMonthly, $key, entity );
    }

    _traderAnalysis ( item ){
        const pt = _.get( this.partyTrading, [ item.PARTY ], {
            party: item.PARTY,
            //根据时间范围计算收入与支出
            incomeOrders: [],
            expenseOrders: [],
            totalExpense: 0,
            totalIncome: 0,
            other: 0,
            otherOrders: [],
        });
        if( item._IE === 0 ) {
            pt.totalIncome += (item.AMOUNT || 0);
            pt.incomeOrders.push(item.ID);
        }
        else if( item._IE === 1 ) {
            pt.totalExpense += (item.AMOUNT || 0);
            pt.expenseOrders.push(item.ID);
        }
        else {
            pt.other += (item.AMOUNT || 0);
            pt.otherOrders.push(item.ID);
        }
        _.set( this.partyTrading, [ item.PARTY ], pt );
    }

    _riskAnalysis ( item ) {
        if( item.SCENE === 'Lease' ) {
            //以party统计, 记录平台数量
            if( this.leasePlatform.has(item.PARTY) ) {
                this.leasePlatform.get(item.PARTY).push(item.ID);
            }
            else {
                this.leasePlatform.set(item.PARTY, [item.ID]);
            }
        }
        else if( item.SCENE === 'Usury' ){
            //以party统计, 记录平台数量
            if( this.usuryPlatform.has(item.PARTY) ) {
                this.usuryPlatform.get(item.PARTY).push(item.ID);
            }
            else {
                this.usuryPlatform.set(item.PARTY, [item.ID]);
            }
        }
        else if( item.SCENE === 'Financial' ) {
            //以party统计, 记录平台数量
            if( this.financialPlatform.has(item.PARTY) ) {
                this.financialPlatform.get(item.PARTY).push(item.ID);
            }
            else {
                this.financialPlatform.set(item.PARTY, [item.ID]);
            }
        }

        if( item._IE === 1 && item.AMOUNT > 10000 ) {
            this.largeAmountOrdersCount.count += 1; //统计大额交易订单数量
            this.largeAmountOrdersCount.orders.push(item.ID);
        }

        if( item.SCENE === 'Lease' || item.SCENE === 'Usury' || item.SCENE === 'Financial' ) {
            //统计近一个月的还款订单
            if( dayjs(item.TIME_YMD).isAfter(dayjs(this.timeSpanEnd).subtract(1, 'month')) ) {
                this.lastMonthRepayment.count += 1;
                this.lastMonthRepayment.amount += item.AMOUNT || 0;
                this.lastMonthRepayment.orders.push(item.ID);
            }
        }

        //统计电费、水费、燃气费等家庭支出
        if( item.SCENE === 'RealEstate' ) {
            console.log(item);
            this.familyConsumption.count += 1;
            this.familyConsumption.amount += item.AMOUNT || 0;
            this.familyConsumption.orders.push(item.ID);
        }
        //统计停车、加油等用车记录
        if( item.SCENE === 'PrivateCar' ) {
            this.vehicleConsumption.count += 1;
            this.vehicleConsumption.amount += item.AMOUNT || 0;
            this.vehicleConsumption.orders.push(item.ID);
        }
    }

    //活跃分析
    _activeAnalysis () {
        //微信活跃度
        //支付宝活跃度
        //日平均活跃度
    }

    //交易行为占比
    _tradingBehaviorAnalysis () {
        //金融行为占总体交易额比重
    }
}